import { Dialog, DialogProps } from "../ui/Dialog"
import { useTranslation } from "react-i18next"
import { Button } from "../ui/Button"
import { Icon } from "../icons/Icon"
import { ShortcutKey } from "./ShortCutsDialog"
import { popDialog } from "@/store/dialogs-state"
import { markOnboardingShown } from "@/store/app-state"

export const CullingOnboardingDialog = (props: Partial<DialogProps>) => {
	const { t } = useTranslation("components")
	const handleContinue = () => {
		markOnboardingShown("cullingShown")
		popDialog()
	}

	return (
		<Dialog
			{...props}
			contentSize="sm-h-auto"
			trackingViewName="onboarding_culling_how_to"
			disableClose
			bottomButtons={
				<div className="flex w-full flex-1 flex-row items-center justify-end">
					<Button
						trackingLabel="culling_onboarding_continue"
						variant="primary"
						onClick={handleContinue}
					>
						{t("common:action.continue")}
					</Button>
				</div>
			}
		>
			<div className="flex flex-col space-y-6 pb-3">
				<div className="flex flex-col space-y-2">
					<h2 className="text-xl font-bold text-base-50">
						{t("cullingOnboardingDialog.howToCull")}
					</h2>
					<p className="text-sm text-base-300">
						{t("cullingOnboardingDialog.howToCullDescription")}
					</p>
				</div>

				<div className="flex flex-row items-center space-x-2">
					<div className="flex flex-row items-center space-x-1">
						<Icon name="flagged" size={16} />
						<Icon name="rejected" size={16} className="text-base-500" />
					</div>
					<div className="mx-1 h-4 w-px bg-base-600" />
					<div className="flex flex-row items-center space-x-0">
						{Array(5)
							.fill(0)
							.map((_, index) => (
								<Icon
									key={index}
									className={index < 3 ? "fill-base-200" : "fill-base-500"}
									name="star_fill"
									size={16}
								/>
							))}
					</div>

					<div className="mx-1 h-4 w-px bg-base-600" />
					<div className="size-3 rounded-full bg-blue-500" />
				</div>

				<div className="flex flex-col space-y-3">
					<div className="flex flex-row items-center justify-between">
						<div className="text-sm">{t("cullingOnboardingDialog.setStarRating")}</div>
						<div className="flex flex-row items-center space-x-1">
							<ShortcutKey>1</ShortcutKey>
							<div className="text-xs">-</div>
							<ShortcutKey>5</ShortcutKey>
						</div>
					</div>
					<div className="flex flex-row items-center justify-between">
						<div className="text-sm">
							{t("cullingOnboardingDialog.removeStarRating")}
						</div>
						<ShortcutKey>0</ShortcutKey>
					</div>
					<div className="flex flex-row items-center justify-between">
						<div className="text-sm">{t("cullingOnboardingDialog.setColorLabel")}</div>
						<div className="flex flex-row items-center space-x-1">
							<ShortcutKey color="bg-red-500 bg-opacity-50">6</ShortcutKey>
							<ShortcutKey color="bg-yellow-500 bg-opacity-50">7</ShortcutKey>
							<ShortcutKey color="bg-green-500 bg-opacity-50">8</ShortcutKey>
							<ShortcutKey color="bg-blue-500 bg-opacity-50">9</ShortcutKey>
						</div>
					</div>
					<div className="flex flex-row items-center justify-between">
						<div className="text-sm">{t("cullingOnboardingDialog.flagPhoto")}</div>
						<ShortcutKey>P</ShortcutKey>
					</div>
					<div className="flex flex-row items-center justify-between">
						<div className="text-sm">{t("cullingOnboardingDialog.rejectPhoto")}</div>
						<ShortcutKey>X</ShortcutKey>
					</div>
					<div className="flex flex-row items-center justify-between">
						<div className="text-sm">{t("cullingOnboardingDialog.unflagPhoto")}</div>
						<ShortcutKey>U</ShortcutKey>
					</div>
				</div>
			</div>
		</Dialog>
	)
}
